import { Component, ViewChild } from '@angular/core';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { ViewController, NavParams, Keyboard } from 'ionic-angular';
import { StaffAuthProvider } from '../../providers/staff-auth/staff-auth';
import { AppState } from '../../config/state';
import { ApiProvider } from '../../providers/api/api';
import { DatabaseProvider } from '../../providers/database/database';
import { InAppBrowser } from '@ionic-native/in-app-browser';

/**
 * Generated class for the CoRoamLoginComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-roam-login',
  templateUrl: 'co-roam-login.html'
})
export class CoRoamLoginComponent {
  loggingIn = false;
  authType = 0; // 0 - default; 1 - sso
  private username: string;
  private password: string;
  private logo: string;
  private cfg: any;
  private isRoamLite = false;
  @ViewChild('usernameInput') usernameInput;
  @ViewChild('passwordInput') passwordInput;
  constructor(private toast : ToastAlertsProvider, private _db: DatabaseProvider, private viewCtrl : ViewController, private staffAuth : StaffAuthProvider, private state : AppState, private navParams : NavParams, private _apiService: ApiProvider, private _keyboard: Keyboard, private _inAppBrowser: InAppBrowser) {
    this.cfg = this.navParams.get('config');
    this.isRoamLite = this.state.isRoamLite;
    this.logo = (this.cfg.settings !== undefined && this.cfg.settings.customImages !== undefined ? this.cfg.settings.customImages.staffLogin : './assets/imgs/c-icon-512.png');
  }

  submitLogin(){
    this._keyboard.close();
    if (!this.username || !this.password){
      this.toast.showAlert('', 'Please fill out all details');
    } else {
      this.loggingIn = true;
      this.staffAuth.authUser(this.username, this.password, this.cfg).then(deets => {
        console.log("deets", deets);
        if (deets && deets.id){
          this.loggingIn = false;
            this.viewCtrl.dismiss(true);
        } else {
          this.loggingIn = false;
          this.toast.showAlert('', 'Could not authenticate staff member');
        }
      });
    }
  }

  handleEnter(){
    if (!this.password || this.password.length <= 0) {
      this.passwordInput.setFocus();
    } else if (!this.username || this.username.length <= 0) {
      this.usernameInput.setFocus();
    } else {
      this.submitLogin();
    }
  }

  scrollToInput(event){
    setTimeout(()=>event._elementRef.nativeElement.scrollIntoView({block: "center"}), 100);
  }

  ssoLogin() {
    if (!this.username){
      this.toast.showAlert('', 'Please fill out all details');
    } else {
      const ref = this._inAppBrowser.create(`${this.state.ssoUrl}?mode=app&username=${this.username}`, "_blank", `location='yes',footer=no,hideurlbar=yes,closebuttoncaption=Back,toolbarposition=top,closebuttoncolor=#ffffff,fullscreen=no,clearsessioncache=yes,hidenavigationbuttons=yes`);
      ref.on('loadstart').subscribe(event => {
        if (event.url.startsWith('http://auth/login')) {
          ref.close();
          this.loggingIn = true;
          const params = new URLSearchParams(event.url);
          this.staffAuth.setAuthentication(this.username, +params.get('level'), params.get('key'), params.get('secret'), params.get('firstName'), params.get('lastName')).then((data) =>{
            this.loggingIn = false;
            this.viewCtrl.dismiss(true);
          })
        } else if (event.url.startsWith('http://auth/error')) {
          ref.close();
          const params = new URLSearchParams(event.url);
          if (params.get('message')) {
          alert(params.get('message'));
          } else {
            alert("Unable to complete SSO authentication");
          }
        }
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/co-roam-login/co-roam-login.ts